<template>
  <el-input
    v-model="searchQuery"
    placeholder="Search by First Name, Last Name, Email"
    class="flex-basis-grow"
    clearable
  />
</template>

<script>
export default {
  name: 'Search',
  computed: {
    searchQuery: {
      get() {
        return this.$store.getters['filters/keyword']
      },
      set(value) {
        this.$store.commit('filters/keyword', value)
      }
    }
  }
}
</script>
